(function () {

    a3_cabin_reports.directive('releaseWarning', releaseWarning);

       /**
   * @memberof CabinReports
   * @ngdoc directive
   * @name releaseWarning
   * @restrict E
   * @description
   *   Soft rules alert in release
   * @example
   *   Usage:
   *   <release-warning></release-warning>
   * @ngInject
   */

    function releaseWarning() {
        function link(scope, attrs) {
            scope.filterSelectedTrainee = filterSelectedTrainee;
            scope.warningTrainees = scope.trainees.filter(x => !x.Session.Absent && x.ShowReleaseWarning);

            function filterSelectedTrainee(){
                return function( trainee ) {
                    var showTrainee = false;
                    if(scope.selectedTrainee){
                        showTrainee = trainee.CrewId == scope.selectedTrainee.CrewId;
                    }
                    return showTrainee;
                };
            }

        }

        return {
            restrict: 'E',
            templateUrl: "views/Training/releaseWarning.tpl.html",
            scope : false,
            terminal: true,
            link: link
        }
    }
})();